<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card body-class="p-0">
          <template v-slot:body>
            <div class="iq-edit-list">
              <tab-nav
                :pills="true"
                class="iq-edit-profile d-flex nav-justified"
              >
                <tab-nav-items
                  class="p-0"
                  :active="step == 1"
                  href="#selectRecipients"
                  title="Recipients"
                  v-on:click.native="fnGetNext(1)"
                />
                <tab-nav-items
                  class="p-0"
                  :active="step == 2"
                  href="#selectPDFTemplate"
                  title="Document Template"
                  v-on:click.native="fnGetNext(2)"
                />
                <tab-nav-items
                  class="p-0"
                  :active="step == 3"
                  href="#selectEmailTemplate"
                  title="Email Template"
                  v-on:click.native="fnGetNext(3)"
                />
              </tab-nav>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="12">
        <iq-card>
          <template v-slot:body>
            <div class="iq-edit-list-data">
              <tab-content id="pills-tabContent-2">
                <tab-content-item
                  :active="step == 1"
                  id="selectRecipients"
                  v-show="step == 1"
                >
                  <div>
                    <appStep1 ref="quoteStep1"></appStep1>
                  </div>
                </tab-content-item>
                <tab-content-item
                  :active="step == 2"
                  id="selectPDFTemplate"
                  v-show="step == 2"
                >
                  <div>
                    <appStep2 ref="quoteStep2"></appStep2>
                  </div>
                </tab-content-item>
                <tab-content-item
                  :active="step == 3"
                  id="selectEmailTemplate"
                  v-show="step == 3"
                >
                  <div>
                    <appStep3 ref="quoteStep3"></appStep3>
                  </div>
                </tab-content-item>
              </tab-content>

              <appNavBar></appNavBar>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import appStep1 from './EMStep1.vue'
import appStep2 from './EMStep2.vue'
import appStep3 from './EMStep3.vue'
import appNavBar from './EMWizardNavBar.vue'
export default {
  name: 'QuoteEdit',
  props: ['quoteType'],
  components: {
    appStep1,
    appStep2,
    appStep3,
    appNavBar
  },
  data() {
    return {
      quoteId: 83713,
      mode: 'edit',
      isErrorStep: 2
    }
  },
  computed: {
    ...mapGetters(['getEMWizardStep']),
    step() {
      return this.getEMWizardStep
    }
  },
  methods: {
    ...mapActions(['fetchEMWizardStep']),
    fnSections() {
      if (this.step == 1) {
        this.toggleAddClass('#selectRecipients')
        this.toggleRemoveClass('#selectPDFTemplate')
        this.toggleRemoveClass('#selectEmailTemplate')
      } else if (this.step == 2) {
        this.toggleRemoveClass('#selectRecipients')
        this.toggleAddClass('#selectPDFTemplate')
        this.toggleRemoveClass('#selectEmailTemplate')
      } else if (this.step == 3) {
        this.toggleRemoveClass('#selectRecipients')
        this.toggleRemoveClass('#selectPDFTemplate')
        this.toggleAddClass('#selectEmailTemplate')
      }
    },
    toggleAddClass(url) {
      this.toggleRemoveClass('#selectRecipients')
      this.toggleRemoveClass('#selectPDFTemplate')
      this.toggleRemoveClass('#selectEmailTemplate')

      var el = document.querySelector(`.iq-edit-list a[href="${url}"].nav-link`)
      el.classList.add('active')
    },
    toggleRemoveClass(url) {
      var el = document.querySelector(
        `.iq-edit-list a[href="${url}"].nav-link.active`
      )

      if (el) {
        el.classList.remove('active')
      }
    },
    fnGetNext(stepNumber) {
      // this.step = stepNumber
      this.fetchEMWizardStep(stepNumber)
      // this.fnSections()
    },
    isErrorExists(isErrorStep) {
      let res = Object.keys(this.getQuoteErrors).filter((v) =>
        v.startsWith(isErrorStep)
      )

      if (res.length > 0) {
        return 'hasErrors'
      }

      return ''
    }
  },
  created() {},
  watch: {
    getEMWizardStep(newVale) {
      this.fnSections()
    }
  }
}
</script>
<style scoped>
.iq-card.hasErrors,
.nav-item.hasErrors {
  border: 1px red solid;
}
.iq-edit-list li:first-child.hasErrors,
.iq-edit-list li:last-child.hasErrors {
  border: 1px red solid;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
</style>
